import { call, put, select, takeEvery } from "redux-saga/effects";
import { datadogRum } from "@datadog/browser-rum";
import { SET_CUSTOM_ADDRESS, SetCustomAddressAction, setCustomAddressSuccess } from "../actions";
import { getGoogleRouteInfo } from "../../../api";
import { getCommonBenefits, getCurrentLocation, getPartnerDetails, getServiceDetails } from "../../../selector";
import { GoogleRoute } from "../../../types";
import { setDestinationTowInfo } from "../../../utils";
import { getTowServiceDetails } from "../helpers";

function* getCustomAddressDistance(action: SetCustomAddressAction) {
  const placeId = action.payload.place_id;
  const { latitude, longitude } = yield select(getCurrentLocation);
  const origin = { lat: latitude, lng: longitude };

  try {
    const route: GoogleRoute = yield call(getGoogleRouteInfo, origin, placeId);

    const { experience } = yield select(getPartnerDetails);
    const { benefits } = yield select(getCommonBenefits);
    const serviceCostArray = yield select(getServiceDetails);
    const benefitsTowCostInfo = getTowServiceDetails(serviceCostArray);
    const towInfo = setDestinationTowInfo({
      distanceInMeters: route.distance.value,
      experience,
      benefits,
      benefitsTowCostInfo,
    });
    yield put(setCustomAddressSuccess({ ...action.payload, towInfo }));
  } catch (e) {
    datadogRum.addError("[getCustomAddressDistance] Error", e);
  }
}

export function* watchGetCustomAddressDistance() {
  yield takeEvery(SET_CUSTOM_ADDRESS, getCustomAddressDistance);
}
